import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lib-areyousure',
  templateUrl: './areyousure.component.html',
  styleUrls: ['./areyousure.component.scss'],
})
export class AreyousureComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {}
}
